// extracted by mini-css-extract-plugin
export default {"container":"Action_container__aom9z","notAllowed":"Action_notAllowed__iWBcP"};